export function dependencySpecMatches(spec: string, name: string): boolean {
  return spec === name || spec.startsWith(`${name}@`)
}
